import React, { useEffect } from 'react';
import { ClerkLoaded, ClerkLoading, RedirectToSignUp, SignUp } from '@clerk/clerk-react';
import {
  buildAuthSiteEntryUrl,
  buildLocalAuthPath,
  getAuthSiteConfig,
  isClerkSatelliteHost,
  resolveRequestedRedirectUrl,
} from '@/lib/auth';
import { enterMixpanelReplaySurface, leaveMixpanelReplaySurface } from '@/lib/mixpanel';

type ExternalRedirectProps = {
  actionLabel: string;
  targetUrl: string;
};

const ExternalRedirect = ({ actionLabel, targetUrl }: ExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(targetUrl);
  }, [targetUrl]);

  const loadingLabel = `Redirecting to ${actionLabel}…`;

  return (
    <div className="flex h-full w-full items-center justify-center p-6 text-center text-white">
      <div>{loadingLabel}</div>
    </div>
  );
};

const SignUpPage: React.FC = () => {
  const isSatelliteHost = isClerkSatelliteHost();
  const authSiteConfig = getAuthSiteConfig();
  const redirectUrl = resolveRequestedRedirectUrl('/play');
  const signInPath = buildLocalAuthPath('/sign-in', redirectUrl);

  useEffect(() => {
    enterMixpanelReplaySurface('auth');

    return () => {
      leaveMixpanelReplaySurface('auth');
    };
  }, []);

  if (isSatelliteHost) {
    return (
      <div className="flex h-full w-full items-center justify-center p-6 text-center text-white">
        <ClerkLoading>
          <div>Loading sign-up…</div>
        </ClerkLoading>
        <ClerkLoaded>
          <RedirectToSignUp redirectUrl={redirectUrl} />
        </ClerkLoaded>
      </div>
    );
  }

  if (authSiteConfig) {
    const authSiteUrl = buildAuthSiteEntryUrl('/sign-up', redirectUrl);

    return <ExternalRedirect actionLabel="sign-up" targetUrl={authSiteUrl} />;
  }

  return (
    <div className="flex h-full w-full items-center justify-center p-6">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl={signInPath}
        fallbackRedirectUrl={redirectUrl}
        signInFallbackRedirectUrl={redirectUrl}
      />
    </div>
  );
};

export default SignUpPage;
